var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1530,
    height: 1700,
    viewBox: "0 0 1530 1700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1134.43 1104.53C1143.38 1123.71 1128.65 1145.49 1107.53 1144.33L92.9253 1088.69C71.2031 1087.5 59.0781 1063.07 71.2621 1045.05L656.118 179.917C668.302 161.894 695.486 164.044 704.687 183.757L1134.43 1104.53Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.073 618.013C459.46 638.201 433.656 643.96 419.087 628.501L-47.1174 133.823C-62.008 118.023 -54.0301 92.0215 -32.8407 87.2916L644.954 -64.0044C666.143 -68.7342 684.421 -48.5934 677.663 -27.9611L466.073 618.013Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.101 788.206C445.177 807.854 429.29 828.987 408.172 826.687L-105.678 770.723C-127.262 768.372 -138.074 743.416 -125.028 726.062L192.307 303.951C205.354 286.597 232.331 290.051 240.585 310.131L437.101 788.206Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.748 1088.53C421.634 1096 426.285 1122.02 410.217 1135.92L19.2357 1474.01C2.81329 1488.21 -22.8232 1479.13 -26.6423 1457.76L-119.538 937.904C-123.357 916.531 -102.453 899.132 -82.1286 906.766L401.748 1088.53Z",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.057 709.16C858.201 716.534 862.911 742.892 846.567 756.786L233.423 1278.05C216.962 1292.04 191.525 1282.91 187.724 1261.64L45.1404 463.727C41.3397 442.458 62.0398 425.08 82.3292 432.508L838.057 709.16Z",
    stroke: "white",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLines);
export default __webpack_public_path__ + "static/media/bg-lines.f09d4d575a715f458bca5fedd5ac7cfc.svg";
export { ForwardRef as ReactComponent };